import h_tipoSolicitacao from '@/helpers/tipo-solicitacao.js';
import validadores from '@/helpers/validadores';

export default {
  usuario: {
    nome: function(nome) {
      return [
        (nome != undefined && nome != null && nome != '') || 'Você não pode deixar este campo em branco',
        (nome && nome.length >= 3 && nome.length <= 155) || 'O nome deve ter entre 3 e 155 caracteres'
      ];
    },
    email: function(email, emailEmUso) {
      return [
        (email != undefined && email != null && email != '') || 'Você não pode deixar este campo em branco',
        (email && /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,3})$/.test(email)) || 'Este formato de e-mail não é válido',
        (email && email.length > 0 && email.length <= 255) || 'A E-mail pode ter no máximo 255 caracteres',
        (email && emailEmUso == false) || 'Este e-mail já está em uso'
      ];
    },
    emailValido: function(email) {
      return [
        (email != undefined && email != null && email != '') || 'Você não pode deixar este campo em branco',
        (email && /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,3})$/.test(email)) || 'Este formato de e-mail não é válido',
        (email && email.length > 0 && email.length <= 255) || 'A E-mail pode ter no máximo 255 caracteres',
      ];
    },
    status: function(status) {
      return [
        (status != undefined && (status == true || status == false)) || 'Você não pode deixar este campo em branco'
      ];
    },
    perfil: function(perfil) {
      return [
        (perfil.id != undefined && perfil.id != null && perfil.id != '' &&
        perfil.descricao != undefined && perfil.descricao != null && perfil.descricao != '') || 'Você não pode deixar este campo em branco'
      ];
    },
    restricaoAcesso: function(tipoSolicitacaoRestricao) {
      let restricaoValida = false;

      if (tipoSolicitacaoRestricao == null) {
        tipoSolicitacaoRestricao = h_tipoSolicitacao.tipoSolicitacaoList()[0];
      }
      
      h_tipoSolicitacao.tipoSolicitacaoList().forEach(tipoSolicitacao => {
        if (tipoSolicitacaoRestricao.id == tipoSolicitacao.id) {
          restricaoValida = true;
        }
      })

      return [
        (restricaoValida) || 'Este valor não é válido'
      ]
    }
  },
  telefone: {
    ddd: function(ddd, obrigatorio) {
      return [
        (ddd != undefined && ddd != null && ddd != '') || !obrigatorio || 'Você não pode deixar este campo em branco',
        (ddd && ddd.length == 2 && /\d{2}$/g.test(ddd)) || (ddd == '' && !obrigatorio) || 'Você precisa informar um DDD válido'
      ];
    },
    numero: function(numero, obrigatorio) {
      return [
        (numero != undefined && numero != null && numero != '') || !obrigatorio || 'Você não pode deixar este campo em branco',
        (numero && numero.length >= 8 && numero.length <= 15 && /^\+?(0|[1-9]\d*)$/.test(numero)) || (numero == '' && !obrigatorio) || 'Você precisa informar um telefone válido'
      ]
    }
  },
  transportadora: {
    cnpj: function(cnpj) {
      if(cnpj != undefined && cnpj != null && cnpj != '') {
        return [
          (validadores.validarCNPJ(cnpj)) || 'Você precisa informar um CNPJ válido'
        ];
      } else {
        return [
          'Você não pode deixar este campo em branco',
        ];
      }
    },
    razaoSocial: function(razaoSocial) {
      return [
        (razaoSocial != undefined && razaoSocial != null && razaoSocial != '') || 'Você não pode deixar este campo em branco',
        (razaoSocial && razaoSocial.length <= 255) || 'A Razão Social pode ter no máximo 255 caracteres'
      ];
    }
  },
  grupo: {
    nome: function(nome, validadeNomeGrupo) {
      return [
        (nome != undefined && nome != null && nome != '') || 'Você não pode deixar este campo em branco',
        (nome && nome.length >= 3 && nome.length <= 155) || 'O nome deve ter entre 3 e 155 caracteres',
        (validadeNomeGrupo) || 'Nome do grupo já existe'
      ]
    },
    status: function(status) {
      return [
        (status != undefined) || 'Você não pode deixar este campo em branco'
      ]
    },
    estado: function(estado, valido, grupoEstadoEmUso, obrigatorio) {
      const mensagem = grupoEstadoEmUso != null ? `Estado já está vinculado ao grupo ${grupoEstadoEmUso}` : `Estado já está vinculado a um grupo`;
      return [
      //  (estado != undefined && estado != null && estado != '') || 'Você não pode deixar este campo em branco',
        (valido) || mensagem
      ]
    },
    emailRegional: function(email, obrigatorio) {
      return [
        (email != undefined && email != null && email != '') || !obrigatorio || 'Você não pode deixar este campo em branco',
        (email && /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,3})$/.test(email)) || 'Este formato de e-mail não é válido',
        (email && email.length > 0 && email.length <= 255) || 'A E-mail pode ter no máximo 255 caracteres'
      ];
    },
  },
  perfil: {
    descricao: function (descricao, descricaoDePerfilValida) {
      return [
        (descricao != undefined && descricao != null && descricao != '') || 'Você não pode deixar este campo em branco',
        (descricao && descricao.length >= 3 && descricao.length <= 50) || 'A descricao deve ter entre 3 e 50 caracteres',
        (descricaoDePerfilValida) || 'Nome do grupo já existe'
      ];
    },
    status: function (status) {
      return [
        (status != undefined && (status == true || status == false)) || 'Você não pode deixar este campo em branco'
      ];
    }
  },
  endereco: {
    pais: function(pais) {
      return [
        (pais != undefined && pais != null && pais != '') || 'Você não pode deixar este campo em branco'
      ];
    },
    estado: function(estado) {
      return [
        (estado != undefined && estado != null && estado != '') || 'Você não pode deixar este campo em branco',
        (estado && /[A-Z]{2}/g.test(estado)) || 'Você precisa informar uma UF válida'
      ];
    },
    cidade: function(cidade) {
      return [
        (cidade != undefined && cidade != null && cidade != '') || 'Você não pode deixar este campo em branco'
      ];
    }
  },
  arquivo: {
    proposta: {
      descricao: function(descricao) {
        return [
          (descricao != undefined && descricao != null && descricao != '') || 'Você não pode deixar este campo em branco',
          (descricao.length <= 255) || 'A descrição pode ter no máximo 255 caracteres'
        ]
      }
    },
    propostaAssinada: {
      dataVigenciaDesejada: function(dataVigenciaDesejada) {
        return [
          (dataVigenciaDesejada != undefined && dataVigenciaDesejada != null && dataVigenciaDesejada != '') || 'Você não pode deixar este campo em branco'
        ]
      }
    },
    tiposArquivo: function (tiposArquivo) {
      return [
        (!!tiposArquivo && Object.keys(tiposArquivo).length !== 0) || 'Você não pode deixar este campo em branco'
      ];
    },
    descricao: function (descricao) {
      return [
        !!descricao || 'Você não pode deixar este campo em branco'
      ]
    }
  },
  premioApoliceAnterior: {
    valorPremio: function(apoliceAnterior, valorPremio) {
      return [
        (apoliceAnterior && valorPremio != null && valorPremio != undefined && valorPremio > 0) || 'Você não pode deixar este campo em branco',
        (!apoliceAnterior && valorPremio == null)
      ]
    }
  },
  chat: {
    novaMensagemValida: function(mensagem, sessao, enviando) {
      return [
        (sessao && sessao.aberta) || 'Você não pode enviar mensagens neste status de solicitação',
        (mensagem && mensagem.length > 0 && mensagem.length <= 500) || 'A mensagem deve ter entre 1 e 500 caracteres',
        (!enviando)
      ]
    }
  }
}


// WEBPACK FOOTER //
// ./src/helpers/form-rules.js